import styles from './BasicHeader.module.css'

import {
  SvgOfficialLogoMetropole,
  SvgOfficialLogoVille,
} from '../../../svg/SvgComponents'

const BasicHeader = () => (
  <>
    <header className={styles.header}>
      <div className={styles.logo}>
        <SvgOfficialLogoMetropole />
      </div>
      <div className={styles.logo}>
        <SvgOfficialLogoVille />
      </div>
    </header>
  </>
)

export default BasicHeader
